var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SortableTable',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"default-sort-by":"age","rows":[].concat( _vm.rows ),"key-field":"_key"}},'SortableTable',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }